import React from 'react';
//import CMSMenuList from '../internal/ApplicationUserManagement/AccessRights/CMSMenu/CMSMenuList';
import { t } from 'i18next';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { menucontrol } from '../../features/togglebuttonSlice';
import { PageHitCountApi } from '../../shared/Helper';
import NotificationTables from '../internal/notification/NotificationTables';
import { getFromLocalStorage } from '../../components/helper/authorizationHelper';
import { useState } from 'react';
import { useLocation } from 'react-use';

const AdminHomePage = () => {
  const [epUserID, setEpUserID] = useState(null);
  const { pathname } = useLocation()



  useEffect(() => {
    localStorage.setItem('isHome', false);
  }, []);




  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if(adminID){
        PageHitCountApi( pathname,adminID);
  }
  },[])



  useDispatch(menucontrol(false));
  // return <CMSMenuList />;
  return (
    <div className="pb-5">
      <div className=" flex justify-center  pt-5 mt-3 ">
        <h2 className="text-3xl text-customgreen text-center  w-full  font-bold">{ t('Notifications') }</h2>
      </div>
      <NotificationTables />
    </div>
  );
};

export default AdminHomePage;
